import React, { createContext, useContext, useEffect, useState } from "react";
import { BASE_URL } from "../config/apiConfig";

const ManagedashboardContext = createContext();
export const useManagedashboard = () => useContext(ManagedashboardContext);

export const ManagedashboardProvider = ({ children }) => {
  const [teamData, setTeamData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const token = localStorage.getItem("token");

  // ✅ Fetch Team / Manager Dashboard Data
  const fetchTeamData = async () => {
    try {
      setLoading(true);
      setError("");

      const res = await fetch(`${BASE_URL}/team-management`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (res.status === 401) {
        setError("Session expired. Please log in again.");
        return;
      }

      const data = await res.json();

      if (data.status === true) {
        setTeamData(data.data);
      } else {
        setError(data.message || "Failed to fetch team data");
      }
    } catch (err) {
      console.error(err);
      setError("Error fetching team data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) fetchTeamData();
  }, [token]);

  return (
    <ManagedashboardContext.Provider
      value={{
        teamData,
        loading,
        error,
        fetchTeamData,
      }}
    >
      {children}
    </ManagedashboardContext.Provider>
  );
};